import lerp from '@14islands/lerp';

/**
 * The roundedLerp function is a utility function that calculates a linear interpolation (lerp) between two values (start and end)
 * and returns the result rounded to a specified number of decimal places.
 * @param {number} start The start value for the interpolation.
 * @param {number} end The end value for the interpolation.
 * @param {number} frameDelta The frame delta value used in the interpolation calculation.
 * @param {number} [round=3] The number of decimal places to round the result to, with a default value of 3.
 * @param {number} [alpha=0.1] The alpha value used in the interpolation calculation, with a default value of 0.1.
 * @param {number} [targetFps=60] The target frames per second (FPS) used in the interpolation calculation, with a default value of 60.
 * @returns {number} The rounded linear interpolation result.
 */

export const roundedLerp = (start: number, end: number, frameDelta: number, round = 3, alpha = 0.1, targetFps = 60) =>
	Number(lerp(start, end, alpha, frameDelta, targetFps).toFixed(round));
